<div class="preloader" *ngIf="isSpinnerVisible">
    <div class="spinnerImage text-center">
        <h3 >{{"PageTitle1B"|translate}}</h3>
        <div class="spinner m-t-10 m-b-10">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
        </div>
        <h5 class="m-t-0 text-info small text-success">{{"615"|translate}}</h5>
    </div>
</div>